import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import '@/assets/less/reset.less'
import '@/assets/less/style.less'
import '@/iconfont/iconfont.css'
import 'lib-flexible'
import Vant from 'vant';
import 'vant/lib/index.css'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import store from "@/store";
import '@/assets/less/globle.css'

const app = createApp(App)
app.use(ElementPlus)
app.use(store)
app.use(router)

app.use(Vant)


app.config.productionTip = false;

// 原生
window._AMapSecurityConfig = {
    securityJsCode: 'e32fbdac461f987b4a0efe900ad2042c' // 输入你的jscode
  }
  import VueAMap from 'vue-amap';

//  VueAMap
// app.use(VueAMap);
// VueAMap.initAMapApiLoader({
//   //申请地址 https://lbs.amap.com/ 选择web端jsAPI
//   key: 'fd9bbea05ff5963f8aa184b4368f81a5',
//   // 插件集合，用到什么插件就使用什么插件
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
//   v: '1.4.4', // 高德sdk版本，最新的sdk已经出到了2.0
//   //官网解释：JSAPI 2.0 提供的开发接口与 1.4 版本达到 99%的兼容度，但是为了保证插件的稳定性我们还是选择1.4.4。
// })



app.mount("#app");
